import { Injectable } from '@angular/core';

import { ErrorService } from './error.service';
import { HttpService } from './http.service';

import { Customer } from '@models/customer';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  constructor(
    private httpService: HttpService,
    private errorService: ErrorService
  ) { }

  public getCustomers(): Promise<Customer[]> {
    return new Promise((resolve, reject) => {
      return this.httpService.get(`**/customers/getAll`).then((response) => {
        return resolve(response);
      }).catch((error: any) => {
        this.errorService.printError(error);

        return reject();
      });
    });
  }

  public getCustomer(id: string | null): Promise<Customer> {
    return new Promise((resolve, reject) => {
      return this.httpService.get(`**/customers/get`, {
        partyId: id,
      }).then((response: Customer) => {
        return resolve(response);
      }).catch((error: any) => {
        this.errorService.printError(error);

        return reject();
      });
    });
  }

  public createCustomer(
    name: string,
    customerNo?: string,
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      return this.httpService.post(`**/customers/create`, {
        customerNo,
        name,
      }).then((result: any) => {
        return resolve(result.partyId);
      }).catch((error: any) => {
        this.errorService.printError(error);

        return reject(error);
      })
    })
  }

  public getCustomerEmployees(partyId: string): Promise<string[]> {
    let employees: string[] = [];
    return new Promise((resolve, reject) => {
      return this.httpService.get(`**/customers/getEmployees`, { partyId }).then((result: string[]) => {
        if (result) {
          for (const employee of result) {
            employees.push(employee);
          }
        }
        return resolve(employees);
      }).catch((error: any) => {
        this.errorService.printError(error);

        return reject(error);
      })
    })
  }

  public requestExport(): Promise<void> {
    return new Promise((resolve, reject) => {
      return this.httpService.get(`**/customers/requestExport`).then(() => {
        return resolve();
      }).catch((error: any) => {
        this.errorService.printError(error);

        return reject();
      });
    });
  }

}
